import { useEffect, useRef, useState } from "react";
import httpApiCall from "../service/api.service";
import {
  getStorageValue,
  zipObjectCovert,
  getZipCode,
  getProfileData,
  setStorageKey,
  Regex,
} from "../service/shared.service";
import toastr from "../components/elements/toast";
import { Link, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import {
  ErrorMessage,
  Field,
  Form,
  Formik,
  FormikProvider,
  useFormik,
} from "formik";
import * as Yup from "yup";
import Autocomplete, { usePlacesWidget } from "react-google-autocomplete";
import "./Modal.scss";
import { useDispatch, useSelector } from "react-redux";
import { PreviewImage, business, businesses, capture, partner } from "../assets/assets";
import ReactCrop, { Crop } from "react-image-crop";
import "react-image-crop/src/ReactCrop.scss";
import Spinner from "react-bootstrap/Spinner";
import { log } from "console";
import WebsiteLiveModal from "./WebsiteLiveModal";
import InputMask from "react-input-mask";
import { savePartnerData } from "../Redux/Slices/MainSlice";

const toastrService = new toastr(true);

export const AddWebsiteModel = (props: any) => {
  const dispatch = useDispatch();
  const [hidezipCode, setHidezipCode] = useState(false);

  const navigate = useNavigate();
  const [sppiner, setSppiner] = useState(false);
  // const [country_code, setCountryCode] = useState("");
  const [radioEmail, setRadioEmail] = useState(false);
  const [radioPhone, setRadioPhone] = useState(false);
  const [addEmail, setAddEmail] = useState(true);
  const [addPhone, setAddPhone] = useState(true);
  const [alternatePhone, setAlternatePhone] = useState(true);
  const [alternateEmail, setAlternateEmail] = useState(true);
  const [showAddress, setShowAddress] = useState(true);
  let [bussiness, setBussiness] = useState(1);
  let [webLiveOpen, setWebLiveOpen] = useState(false);
  const [changeInfo, setChangeInfo] = useState(1);
  const GetData = getStorageValue("partnerData");
  const [image, setImage] = useState("");
  const [url, setUrl] = useState("");
  const [show, setShow] = useState(false);
  const [state, setState] = useState("");
  const [dataValueOne, setDataValueOne] = useState("");
  const [dataValueTwo, setDataValueTwo] = useState("");
  const [limitOne, setLimitOne] = useState('Biography must be 150 words long');
  const [limitTwo, setLimitTwo] = useState('Biography must be 150 words long');
  const formSubmit = useRef<any>(null);
  const [crop, setCrop] = useState<Crop>({
    unit: "%",
    x: 25,
    y: 25,
    width: 50,
    height: 50,
  });
  
  let [phoneRegex, setPhoneRegex]: any = useState("");
  const makeItLive: any =
    GetData && GetData["partner_profile"] && GetData["partner_profile"][0];

  let countries = [];
  countries.push(GetData?.country_currency_info?.country["country_code"]);
  const US_UT_country_codes = ["VI", "PR", "GU", "AS", "MP"];
  if (GetData?.country_currency_info?.country["country_code"] == "US") {
    countries = [...countries, ...US_UT_country_codes];
  }

  const countryRestrictions = GetData
    ? { country: countries }
    : undefined;

  const [personalizedInfo, setPersonalizedInfo] = useState({
    partner_email:
      makeItLive && makeItLive["partner_email"]
        ? makeItLive["partner_email"]
        : "",
    partner_mobile:
      makeItLive && makeItLive["partner_mobile"]
        ? makeItLive["partner_mobile"]
        : "",
    partner_address:
      makeItLive && makeItLive.partner_address
        ? makeItLive.partner_address
        : "",
    zip: makeItLive && makeItLive.zip ? makeItLive.zip : "",
    city_id:makeItLive && makeItLive.city_id ? makeItLive.city_id : "",
    state_id: makeItLive && makeItLive.state_id ? makeItLive.state_id : "",
    state_name: makeItLive && makeItLive.state_name ? makeItLive.state_name : "",
    city_name: makeItLive && makeItLive.city ? makeItLive.city : "",
    profile_image: makeItLive && makeItLive.partner_image ? makeItLive.partner_image : "",
    textarea2: makeItLive && makeItLive.p2p_bio ? makeItLive.p2p_bio : "",
    textarea1: makeItLive && makeItLive.bio ? makeItLive.bio : "",
    partner_alternate_mobile:
      makeItLive && makeItLive.partner_alternate_mobile
        ? makeItLive.partner_alternate_mobile
        : "",
    partner_alternate_email:
      makeItLive && makeItLive["partner_alternate_email"]
        ? makeItLive["partner_alternate_email"]
        : "",
    partner_email_checkbox:  makeItLive.show_email == 1? true : false,
    phone_number_checkbox:  makeItLive.show_phone == 1? true : false,
    partner_email_alternate_checkbox:  makeItLive.show_alt_email == 1? true : false,
    partner_number_alternate_checkbox:  makeItLive.show_alt_phone == 1? true : false,
    show_address: makeItLive.show_address == 1? true : false,
  });

  useEffect(() => {
    // if (
    //   partnerData &&
    //   partnerData.GetData &&
    //   partnerData.GetData.country_currency_info &&
    //   partnerData.GetData.country_currency_info.country
    // ) {
    //   partnerData["country_code"] =
    //     partnerData.GetData.country_currency_info.country["country_code"];
    //   setCountryCode(partnerData["country_code"]);
    // }
    if (
      GetData &&
      GetData.country_currency_info &&
      GetData.country_currency_info.country
    ) {
      updateMasking(
        GetData.country_currency_info.country["country_phone_format"]
      );
    }
   
  }, [GetData]);
  useEffect(() => {
    setDataValueTwo(makeItLive && makeItLive.p2p_bio ? makeItLive.p2p_bio :'')
    setDataValueOne(makeItLive && makeItLive.bio?makeItLive.bio:'')
    setLimitOne(makeItLive && makeItLive.bio?'':'Biography must be 150 words long')
    setLimitTwo(makeItLive && makeItLive.p2p_bio?'':'Biography must be 150 words long')
  },[])

  const updateMasking = (format: "") => {
    const phoneRegexVar = format?.replace(/#/g, "9");
    phoneRegex = phoneRegexVar;
    setPhoneRegex(phoneRegexVar);
  };

  const onPhoneChange = (event: any, setFieldValue: any) => {
    const name = event.target.name;
    if (event.target.value) {
      event.target.value = event.target.value.replace(/[^0-9]+/g, "");
    }
    // console.log(event.target.value);
    setPersonalizedInfo((businessData) => ({
      ...businessData,
      [name]: event.target.value,
      // partner_alternate_mobile: event.target.value,
    }));
    setFieldValue([name], event.target.value);
  };

  const placeSelectedZip = async (place: any, setFieldValue: any) => {
    setSppiner(true);

    setHidezipCode(true);
    const placeData = await getZipCode(zipObjectCovert(place));
    personalizedInfo.city_name = placeData.city;
    personalizedInfo.state_name = placeData.state_name;
    personalizedInfo.zip = placeData.zip;
    setPersonalizedInfo((personalizedInfo) => ({
      ...personalizedInfo,
      state_name: placeData.state_name,
      city_name: placeData?.city,
      city_id: placeData.city_id,
      zip: placeData.zip,
    }));
    setFieldValue("zip", placeData.zip);
    setSppiner(false);
    setHidezipCode(false);
  };

  const handleSubmit = async (formData?: any) => {
    // console.log(formData, "FormDta");

    if (formData && !formData.partner_address) {
      toastrService.showError("Please enter address.");
      return;
    }
    if (!image && !personalizedInfo.profile_image) {
      toastrService.showError("Please upload profile image");
      return;
    }

    if (formData) {
      if (bussiness == 1) {
        if (dataValueTwo && limitTwo) {
          setBussiness(2);
          return;
        }
        if(limitOne) {
          setChangeInfo(2);
          return;
        }
      }
      if (bussiness == 2) {
        if (dataValueOne && limitOne) {
          setBussiness(1);
          return;
        }
        if(limitTwo){
          setChangeInfo(2);
          return;
        }
      }
    }
    setSppiner(true);

    let profileData = getStorageValue("partnerProfile");
    profileData = profileData && profileData[0];

    const token = getStorageValue("partnerToken");
    const body: any = {
      partner_id: profileData.partner_id,
      bio: dataValueOne,
      address: formData.partner_address,
      zip_code: personalizedInfo.zip,
      city_id: personalizedInfo.city_id,
      profile_image: image,
      partner_mobile: formData.partner_mobile,
      p2p_bio: dataValueTwo,
      access_token: token,
    };
    body["show_address"] = showAddress ? 1 : 0;
    body["show_phone"] = addPhone ? 1 : 0;
    body["show_email"] = addEmail ? 1 : 0;
    if (radioEmail && formData && formData.partner_alternate_email) {
      body["partner_alternate_email"] = formData.partner_alternate_email;
      body["show_alt_email"] = alternateEmail ? 1 : 0;
    }
    if (radioPhone && formData && formData.partner_alternate_mobile) {
      body["partner_alternate_mobile"] = formData.partner_alternate_mobile;
      body["show_alt_phone"] = alternatePhone ? 1 : 0;
    }
    let resp = await SavePersonalizedInfo(body);
    if (resp) {
      setSppiner(false);
      // console.log(resp);
      props.onHide();
      const profile = await getProfileData();
      if (profile && profile.is_error == 0) {
        setStorageKey("partnerData", profile);
        navigate("/app/profile");
        dispatch(savePartnerData(profile));
        sessionStorage.setItem("activeTab", JSON.stringify(2));
        sessionStorage.setItem("Tabs", JSON.stringify(2));
        props.showDomailModal();
      } else {
        toastrService.showError(profile.original_text || profile.err);
      }
    }else {
      setSppiner(false);

    }
  };
  const validationSchema = Yup.object({
    partner_email: Yup.string()
      .email("Please enter valid email address.")
      .required("Please enter valid email address."),
    partner_mobile: Yup.string()
      .required("Please Enter phone number")
      .matches(Regex.phoneRegExp, "Phone number is not valid"),
    partner_address: Yup.string().required("Please enter address."),
    partner_alternate_email: Yup.string().when([], (i, schema) => {
      return radioEmail
        ? schema.required("Please enter alternate address.")
        : schema.notRequired();
    }),
    partner_alternate_mobile: Yup.string().when([], (i, schema) => {
      return radioPhone
        ? schema
            .matches(Regex.phoneRegExp, "Invalid phone number")
            .required("Please enter alternate mobile.")
        : schema.notRequired();
    }),
    // city_name: Yup.string().required("City is required"),
    // state_name: Yup.string().required("State is required"),
    zip: Yup.string().required("ZipCode is required"),
  });
  // console.log(validationSchema);

  const personWeb = (s: any) => {
    const information = s.target.value;
    if (information == 1) {
      setChangeInfo(1);
    } else {
      if (
        information == 2 &&
        (!personalizedInfo.partner_email ||
          !personalizedInfo.partner_mobile ||
          !personalizedInfo.partner_address ||
          !personalizedInfo.zip)
      ) {
        setTimeout(() => {
          if (formSubmit.current) {
            formSubmit.current?.handleSubmit();
          }
        }, 0);
      } else {
        setChangeInfo(2);
      }
    }
  };
  const uploadImage = (e: any) => {
    const file = e?.target?.files?.[0];
    setImage(file);
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        if (event.target) {
          setUrl(event.target.result);
        }
      };
      reader.readAsDataURL(file);
      handleShow();
      e.target.value = null;
    } else {
      console.error("Please select an image file.");
    }
  };

  const handleShow = () => setShow(true);

  const getCroppedImg = async (image: any, crop: any, fileName: any) => {
    image = await createImage(url);
    const uploadedImage: any = document.getElementById("uploadedImage");
    const scaleX = image.naturalWidth / uploadedImage?.clientWidth;
    const scaleY = image.naturalHeight / uploadedImage?.clientHeight;
    // new OffscreenCanvas(image.naturalWidth * image.width, image.naturalHeight * image.height) //
    const canvas = document.createElement("canvas");
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx: any = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob: any) => {
        if (!blob) {
          toastrService.showError("Please crop the image");
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        // window.URL.revokeObjectURL(this.fileUrl);
        const fileUrl = window.URL.createObjectURL(blob);
        // console.log(fileUrl);
        resolve(fileUrl);
      }, "image/jpeg");
    });
  };
  const createImage = (url: any) =>
    new Promise((resolve, reject) => {
      const image: any = new Image();
      image.addEventListener("load", () => resolve(image));
      image.addEventListener("error", (error: any) => reject(error));
      image.setAttribute("crossOrigin", "anonymous"); // needed to avoid cross-origin issues on CodeSandbox
      image.src = url;
    });
  const handleClose = () => {
    setShow(false);
    setCrop({
      unit: "%", // Can be 'px' or '%'
      x: 25,
      y: 25,
      width: 50,
      height: 50,
    });
  };
  const handleFileUpload = async () => {
    // console.log(crop, "Crop");
    const croppedImageUrl: any = await getCroppedImg(url, crop, "test");
    if (croppedImageUrl) {
      setState(croppedImageUrl);
      // setImage(croppedImageUrl);
      handleClose();
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="addWebstieModal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <div>
              <h1> Update Information</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <ul
            id="personWeb"
              className="tabs-wrapper-list mb-3"
              onClick={(e) => personWeb(e)}
            >
              <li value={1} className={changeInfo == 1 ? "bg-white" : ""}>
                {" "}
                Personal Information{" "}
              </li>
              <li value={2} className={changeInfo == 2 ? "bg-white" : ""}>
                {" "}
                Website Bio{" "}
              </li>
            </ul>
          </div>

          <>
            {changeInfo && changeInfo == 1 && (
              <div className="d-flex align-items-center mb-3 img_upload">
                <div className="upload-img">
                  <img src={state ? state : personalizedInfo && personalizedInfo.profile_image ? personalizedInfo.profile_image :capture} alt="" />
                  <input id="updateImg" type="file" accept="image/jpg, image/jpeg, image/png, image/svg" onChange={(e: any) => uploadImage(e)} />
                </div>
                <div className="upload_profile">
                  <h4>Upload Profile Image</h4>
                  <p>
                    Should be at-least 500x500 pixels.
                    <a href={PreviewImage}
                      target="_blank"
                      rel="noreferrer"
                    >
                      View Sample
                    </a>
                  </p>
                </div>
              </div>
            )}
            <Formik
              onSubmit={handleSubmit}
              initialValues={personalizedInfo}
              validationSchema={validationSchema}
              innerRef={formSubmit}
            >
              {({ setFieldValue }) => (
                <Form>
                  {changeInfo && changeInfo == 1 && (
                    <div className="row">
                      <div className="col-md-12 mb-3 email">
                        <div className="col-md-6">
                          <label>Email Address</label>
                          <div>
                            <Field
                            id="partner_email"
                              className="form-control"
                              type="text"
                              name="partner_email"
                              disabled
                            />
                            {!addEmail && (
                              <p
                                className="Add_field"
                                onClick={() => setRadioEmail(!radioEmail)}
                              >
                                {!radioEmail
                                  ? "+ Add Alternate Email"
                                  : "Hide Alternate Email"}
                              </p>
                            )}
                          </div>
                          <small className="text-danger m-2">
                            <ErrorMessage name="partner_email" />
                          </small>
                        </div>
                        <div className="col-md-6 -email">
                          <div className="form-check form-switch mb-0">
                            <label className="form-check-label">
                              <Field
                                type="checkbox"
                                name="partner_email_checkbox"
                                id="toggleCheckbox"
                                className="form-check-input"
                                onClick={(e:any) => {
                                  setAddEmail(e.target.checked);
                                  if (radioEmail) {
                                    setRadioEmail(!radioEmail);
                                  }
                                }}
                              />
                              {addEmail ? "Show on website" : "Hide on website"}{" "}
                            </label>
                          </div>
                        </div>
                      </div>
                      {radioEmail && (
                        <div className="col-md-12 mb-3 email">
                          <div className="col-md-6">
                            <label>Alternative Email Address</label>
                            <div>
                              <Field
                              id="partner_alternate_email"
                                className="form-control"
                                type="text"
                                name="partner_alternate_email"
                              />
                            </div>
                            <small className="text-danger m-2">
                              <ErrorMessage name="partner_alternate_email" />
                            </small>
                          </div>
                          <div className="col-md-6 email">
                            <div className="form-check form-switch mb-0">
                              <label className="form-check-label">
                                <Field
                                  type="checkbox"
                                  name="partner_email_alternate_checkbox"
                                  id="toggleCheckbox"
                                  className="form-check-input"
                                  onClick={(e:any) =>
                                    setAlternateEmail(e.target.checked)
                                  }
                                />
                                Show on website
                              </label>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="col-md-12 mb-3 email">
                        <div className="col-md-6">
                          <label>Phone</label>
                          <div className="position-relative">
                            <span className="code">
                              {
                                GetData.country_currency_info.country[
                                  "mobile_code"
                                ]
                              }
                            </span>
                            <Field>
                              {(props: any) => (
                                <InputMask
                                id="partner_mobile"
                                  type="text"
                                  name="partner_mobile"
                                  mask={phoneRegex}
                                  maskChar={null}
                                  value={personalizedInfo.partner_mobile}
                                  onChange={(event) =>
                                    onPhoneChange(event, setFieldValue)
                                  }
                                  className="text-input form-control phone_masking"
                                />
                              )}
                            </Field>
                          </div>
                          {!addPhone && (
                            <p
                              className="Add_field"
                              onClick={() => setRadioPhone(!radioPhone)}
                            >
                              {!radioPhone
                                ? "+ Add Alternate Phone"
                                : "Hide Alternate Phone"}
                            </p>
                          )}
                          <small className="text-danger m-2">
                            <ErrorMessage name="partner_mobile" />
                          </small>
                        </div>
                        <div className="col-md-6 email">
                          <div className="form-check form-switch mb-0">
                            <label className="form-check-label">
                              <Field
                                type="checkbox"
                                name="phone_number_checkbox"
                                id="toggleCheckbox"
                                className="form-check-input"
                                onClick={(e :any) => {
                                  setAddPhone(e.target.checked);
                                  if (radioPhone) {
                                    setRadioPhone(!radioPhone);
                                  }
                                }}
                              />
                              {addPhone ? "Show on website" : "Hide on website"}{" "}
                            </label>
                          </div>
                        </div>
                      </div>
                      {radioPhone && (
                        <div className="col-md-12 mb-3 email">
                          <div className="col-md-6">
                            <label>Alternative Phone</label>
                            <div className="position-relative">
                              <span className="code">
                                {
                                  GetData.country_currency_info.country[
                                    "mobile_code"
                                  ]
                                }
                              </span>
                              <Field>
                                {(props: any) => (
                                  <InputMask
                                    type="text"
                                    mask={phoneRegex}
                                    maskChar={null}
                                    name="partner_alternate_mobile"
                                    id="partner_alternate_mobile"
                                    value={
                                      personalizedInfo.partner_alternate_mobile
                                    }
                                    onChange={(event) =>
                                      onPhoneChange(event, setFieldValue)
                                    }
                                    className="text-input form-control phone_masking"
                                  />
                                )}
                              </Field>
                            </div>
                            <small className="text-danger m-2">
                              <ErrorMessage name="partner_alternate_mobile" />
                            </small>
                          </div>
                          <div className="col-md-6 email">
                            <div className="form-check form-switch mb-0">
                              <label className="form-check-label">
                                <Field
                                  type="checkbox"
                                  name="partner_number_alternate_checkbox"
                                  id="toggleCheckbox"
                                  className="form-check-input"
                                  onClick={(e:any) =>
                                    setAlternatePhone(e.target.checked)
                                  }
                                />
                                {alternatePhone
                                  ? "Show on website"
                                  : "Hide on website"}{" "}
                              </label>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="col-md-12 mb-3 email">
                        <div className="col-md-6">
                          <label>Address</label>
                          <div>
                            <Field
                              className="form-control"
                              type="text"
                              name="partner_address"
                            />
                          </div>
                          <small className="text-danger m-2">
                            <ErrorMessage name="partner_address" />
                          </small>
                        </div>
                        <div className="col-md-6 email">
                          <div className="form-check form-switch mb-0">
                            <label className="form-check-label">
                              <Field
                                type="checkbox"
                                name="show_address"
                                id="update_address"
                                className="form-check-input"
                                onClick={(e:any) => setShowAddress(e.target.checked)}
                              />
                              {showAddress
                                ? "Show on website"
                                : "Hide on website"}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-4 mb-3 zip_code">
                        <label>Zip Code</label>
                        <div
                        id="user_zip"
                          style={{
                            border: "solid 1px #dee2e6",
                            borderRadius: "0.375rem",
                            minHeight: "42px",
                          }}
                        >
                          {countryRestrictions && !hidezipCode && (
                            <Autocomplete
                              apiKey={getStorageValue("map_api_key")}
                              className="form-control"
                              style={{
                                width: "100%",
                                height: "40px",
                                paddingLeft: "16px",
                              }}
                              onPlaceSelected={(place) => {
                                placeSelectedZip(place, setFieldValue);
                                setFieldValue(
                                  "state_name",
                                  personalizedInfo.state_name
                                );
                              }}
                              options={{
                                fields: [
                                  "address_components",
                                  "adr_address",
                                  "geometry",
                                  "name",
                                  "formatted_address",
                                ],
                                types: ["(regions)"],
                                componentRestrictions: countryRestrictions,
                              }}
                              defaultValue={
                                GetData && GetData.zip
                                  ? GetData.zip
                                  : personalizedInfo.zip
                              }
                            />
                          )}
                        </div>
                        <ErrorMessage
                          name="zip"
                          component="small"
                          className="text-danger m-2"
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label>City</label>
                        <div>
                          <Field
                          id="update-city"
                            disabled
                            className="form-control"
                            type="text"
                            name="city_name"
                            value={personalizedInfo.city_name}
                          />
                        </div>
                        <small className="text-danger m-2">
                          <ErrorMessage name="city_name" />
                        </small>
                      </div>
                      <div className="col-md-4 mb-3">
                        <label>State</label>
                        <div>
                          <Field
                            disabled
                            id="update-state"
                            className="form-control"
                            type="text"
                            name="state_name"
                            value={personalizedInfo.state_name}
                          />
                        </div>
                        <small className="text-danger m-2">
                          <ErrorMessage name="state_name" />
                        </small>
                      </div>
                    </div>
                  )}
                  {changeInfo && changeInfo == 2 && (
                    <div className="websit">
                      <div className="websit_bio">
                        <div
                          className={`websit_bio_business ${
                            bussiness == 1 ? "colorBack" : ""
                          }`}
                          onClick={() => setBussiness(1)}
                        >
                          <p id="bio">Bio for business website</p>
                        </div>
                        <div
                          className={`websit_bio_business ${
                            bussiness != 1 ? "colorBack" : ""
                          }`}
                          onClick={() => setBussiness(2)}
                        >
                          <p id="p2p_bio">Bio for partner website</p>
                        </div>
                      </div>
                      {bussiness == 1 && (
                        <div className="websit_text">
                          <Field
                            as="textarea"
                            name="textarea1"
                            id="upadte-bio"
                            placeholder="Enter a short bio for your website"
                            value={dataValueOne}
                            onChange={(event:any) => {
                              setDataValueOne(event.target.value)
                              setLimitOne(event.target.value.length < Regex.bioMinLimit ? 'Biography must be 150 words long' : (event.target.value.length > Regex.bioMaxLimit ? 'The biography exceeds the maximum limit of 300 characters' : ''))
                            }}
                          />
                           {!dataValueOne && <p className="text-danger m-2">Please enter Bio</p>}
                      {(dataValueOne && limitOne) && <p className="text-danger m-2">{limitOne}</p>}
                        </div>
                      )}
                      {bussiness == 2 && (
                        <div className="websit_text">
                          <Field
                            as="textarea"
                            name="textarea2"
                            id="update-bio2"
                            placeholder="Enter a short bio for your website"
                            value={dataValueTwo}
                            onChange={(event:any) => {setDataValueTwo(event.target.value)
                              setLimitTwo(event.target.value.length < Regex.bioMinLimit ? 'Biography must be 150 words long' : (event.target.value.length > Regex.bioMaxLimit ? 'The biography exceeds the maximum limit of 300 characters' : ''))
                            }}
                          />
                      {!dataValueTwo && <p className="text-danger m-2">Please enter Bio</p>}
                      {(dataValueTwo && limitTwo) && <p className="text-danger m-2">{limitTwo}</p>}
                        </div>
                      )}
                    </div> 
                  )}
                  <div className="col-12 button_chase mt-3">
                    <button disabled={sppiner} className="loginBtn" type="submit" ref={formSubmit}>
                      Continue
                      {sppiner && (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </>
        </Modal.Body>
      </Modal>
      <div className="image-cropper">
        <Modal
          show={show}
          onHide={handleClose}
          animation={false}
          backdrop="static"
        >
          <Modal.Header closeButton></Modal.Header>
          <Modal.Body>
            <ReactCrop crop={crop} onChange={(c) => setCrop(c)}>
              <img
                src={url}
                alt="Crop me"
                className="w-100"
                id="uploadedImage"
              />
            </ReactCrop>
          </Modal.Body>
          <Modal.Footer className=" d-flex justify-content-between">
            <Button id="handleClose" variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button id="handleUpload" variant="primary" onClick={() => handleFileUpload()}>
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      {webLiveOpen && (
        <WebsiteLiveModal
          show={webLiveOpen}
          onHide={() => {
            setWebLiveOpen(false);
          }}
          domain_type={props.domain_type}
                    template_id={props.template_id}
        />
      )}
    </>
  );
};

export default AddWebsiteModel;

const SavePersonalizedInfo = async (body: any) => {
  try {
    const data = await httpApiCall({
      api: "save_personalized_profile",
      type: "form",
      body,
    });
    if (data && data.is_error) {
      toastrService.showError(data.original_text || data.err);
    } else {
      toastrService.showSuccess("Profile updated.");
      return data;
    }
  } catch (error) {
    toastrService.showError(error);
    return [];
  }
};
